import { useCreate, useNotify } from "react-admin";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";

import * as Axios from "providers/axios";
import { toBase64 } from "utils/files";
import { Dispatch, SetStateAction } from "react";

export function usePhotoUploadSubmitCreate({
  keys,
  redirect,
  resource,
  setIsLoading
}: {
  keys: string[];
  redirect: string;
  resource: string;
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
}) {
  const { api } = Axios.useAxios();
  const mutation = useMutation((payload: { image: string }): any =>
    api.post(`/v1/uploads/image`, payload)
  );
  const navigate = useNavigate();
  const [create] = useCreate();
  const notify = useNotify();

  const onSubmit = async (
    payload: any,
    customOnSuccess?: any,
    customOnError?: any
  ) => {
    if (setIsLoading) {
      setIsLoading(true);
    }
    let finalPayload = payload;
    let finalImage: string | null = null;

    try {
      await Promise.all(
        keys.map(async (key: string) => {
          if (payload?.[key]?.rawFile) {
            const image = (await toBase64(payload?.[key]?.rawFile)) as string;
            const { data } = (await mutation.mutateAsync({ image })) as any;
            finalImage = data.url;

            finalPayload = {
              ...finalPayload,
              [key]: data.url
            };
          }
        })
      );
    } catch (e) {
      notify("An error occurred while uploading images.", {
        type: "error",
        undoable: false,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        duration: 5000
      });
      if (setIsLoading) {
        setIsLoading(false);
      }
      return;
    }

    create(
      resource,
      {
        data: finalPayload
      },
      {
        onSuccess: customOnSuccess
          ? (userData) => customOnSuccess(userData, finalImage)
          : () => navigate(redirect),
        onError: customOnError
          ? (err) => customOnError(err)
          : () => {
              if (setIsLoading) {
                setIsLoading(false);
              }
            }
      }
    );
  };

  return {
    submit: onSubmit
  };
}
